/**
 * NotificationIcon/index.js
 * desc: notification icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const NotificationIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="notification icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.notification.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M14 8.5v5l2 2v1H0v-1l2-2v-5c0-3.08 1.63-5.64 4.5-6.32V1.5C6.5.67 7.17 0 8 0s1.5.67 1.5 1.5v.68c2.86.68 4.5 3.25 4.5 6.32zm-4 9a2 2 0 11-4 0h4z"/></svg>
    </IconButton>
);


export default NotificationIcon;
